export default "__VITE_ASSET__BEYBCTIH__"